/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeCreateManyProductsRequest, serializeOk, type CreateManyProductsRequest, type ErrorResponse, type InternalErrorResponse, type Ok } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/products/bulk
 */
export interface BulkRequestBuilder extends BaseRequestBuilder<BulkRequestBuilder> {
    /**
     * Creates or updates products in bulk, matched on SKU; rows carrying familyKey and optionValues are grouped into product families when the organization has variants enabled. For an agency organization a row's vendorCode names the line the product belongs to and its SKU is stored as {vendorCode}-{sku}, a value already carrying the prefix being left alone, so re-importing an exported file is idempotent; every vendorCode must be one of the organization's vendors, and the whole batch is refused before any write otherwise. Images given as URLs are queued and transferred in the background after the response, so they appear on the products shortly after the import completes; images given by the name of an already-uploaded image are assigned immediately.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: CreateManyProductsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Creates or updates products in bulk, matched on SKU; rows carrying familyKey and optionValues are grouped into product families when the organization has variants enabled. For an agency organization a row's vendorCode names the line the product belongs to and its SKU is stored as {vendorCode}-{sku}, a value already carrying the prefix being left alone, so re-importing an exported file is idempotent; every vendorCode must be one of the organization's vendors, and the whole batch is refused before any write otherwise. Images given as URLs are queued and transferred in the background after the response, so they appear on the products shortly after the import completes; images given by the name of an already-uploaded image are assigned immediately.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: CreateManyProductsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BulkRequestBuilderUriTemplate = "{+baseurl}/api/products/bulk";
/**
 * Metadata for all the requests in the request builder.
 */
export const BulkRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: BulkRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateManyProductsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
